export default "__VITE_ASSET__Cm1U8dzX__"